module.exports.Validation = {
    isValidUTF8: function (buffer) {
        return true;
    }
};